import { render, staticRenderFns } from "./CardDetailWithdrawal.vue?vue&type=template&id=4741e621&"
import script from "./CardDetailWithdrawal.vue?vue&type=script&lang=js&"
export * from "./CardDetailWithdrawal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports